import { ValidationError } from "sequelize"
import {
    RrsTemplateRiskRank,
    RrsTemplateRiskRankDelete,
} from "server/models"
import { GET, POST, validate } from "client/store/utils"
import {
    LangType,
    RrsTemplateRiskRankList,
    RrsTemplateRiskRankValidation,
} from "client/store"

export const LoadAllRrsTemplateRiskRanks = (templateId: number) => (
    GET(`/rrsTemplateRiskRank/templateId/${templateId}`)
    .then((ranks: RrsTemplateRiskRank[]) => {
        const riskRankList: RrsTemplateRiskRankList = {}
        ranks.forEach((rank) => {
            riskRankList[rank.textId] = rank
        })
        return riskRankList
    })
)

export const CreateRrsTemplateRiskRanks = (data: RrsTemplateRiskRank[]) => (
    POST(
        "/rrsTemplateRiskRank/create",
        JSON.stringify(data),
    )
)

export const SaveRrsTemplateRiskRank = (
    rank: RrsTemplateRiskRank,
    lang: LangType,
) => (
    POST(
        "/rrsTemplateRiskRank/save",
        JSON.stringify(rank),
    ).then((res) => {
        const error = res as ValidationError
        return <RrsTemplateRiskRankValidation>validate(error, lang)
    })
)

export const DeleteRrsTemplateRiskRanks = (data: RrsTemplateRiskRankDelete) => (
    POST(
        "/rrsTemplateRiskRank/delete",
        JSON.stringify(data),
    )
)
